// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_RevokeOverrideResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Result of POST /ai/credits/pricing/overrides/{id}/revoke — Full-gated only.
 *
 * A revoke only ever CLOSES the window (valid_to = now) — it never deletes
 * the row. valid_to echoes back the timestamp the window was closed at, so
 * the caller can confirm the close without a second read.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_RevokeOverrideResponseDados {
id: number
valid_to: string
}

export type AiCredits_RevokeOverrideResponse = ApiResponse<AiCredits_RevokeOverrideResponseDados>;

registerResponseContract('AiCredits_RevokeOverrideResponse', {
  id:       { type: 'number',  required: true },
  valid_to: { type: 'string',  required: true },
})
